import React from 'react';
import './FastDrawer.scss';
import PropTypes from 'prop-types';

function FastDrawer({drawerSide, show, children, content, onDrawerBlur, isFullScreen, hideBackdrop}) {
  let customStyle = {};
  const sideClass = drawerSide;
  const showClass = show ? 'slide-show' : 'slide-hide';
  const showBackdrop = !hideBackdrop ? '' : 'hide';

  if (!isFullScreen) {
    customStyle = {
      zIndex: -1,
    };
  }

  return (
    <div className={`cmon-drawer ${showClass}`}>
      <div className={`drawer ${sideClass} ${showClass}`} style={customStyle}>
        {content || children}
      </div>
      <div className={`drawer-backdrop ${showClass} ${showBackdrop}`} onClick={onDrawerBlur} />
    </div>
  );
}

FastDrawer.propTypes = {
  children: PropTypes.node,
  onDrawerBlur: PropTypes.func,
  isFullScreen: PropTypes.bool,
  hideBackdrop: PropTypes.bool,
  drawerSide: PropTypes.oneOf(['left', 'right']),
  show: PropTypes.bool,
  content: PropTypes.any,
};

FastDrawer.defaultProps = {
  children: null,
  show: false,
  content: null,
  drawerSide: 'left',
  onDrawerBlur: () => {},
  isFullScreen: true,
  hideBackdrop: false,
};

export default FastDrawer;
